import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface VideoListenerI
{
    username: string | null;
    newVideoCall: boolean | null;
    videoCallInProgress?: boolean;
    videocallGroupInProgress?: boolean;
    videoEnabled?: boolean;
    audioEnabled?: boolean;
}

export const videoCallAlertSlice = createSlice({
    name: 'videoCallAlert',
    initialState: {
        videoAlert:{
            username: null,
            newVideoCall: null,
            videoEnabled: true,
            audioEnabled: true
        }
    } as { videoAlert: VideoListenerI},
    reducers: {
        setVideoAlert: (state, action: PayloadAction<VideoListenerI>) => {
            state.videoAlert.username = action.payload.username;
            state.videoAlert.newVideoCall = action.payload.newVideoCall;
        },
        setVideoCallInProcess: (state, action: PayloadAction<{videoCallInProgress: boolean}>) => {
            state.videoAlert.videoCallInProgress = action.payload.videoCallInProgress;
        },
        setVideoCallGroupInProcess: (state, action: PayloadAction<{videocallGroupInProgress: boolean}>) => {
            state.videoAlert.videocallGroupInProgress = action.payload.videocallGroupInProgress;
        },
        setVideoCallMuteControl: (state, action: PayloadAction<{muteControl: boolean}>) => {
            state.videoAlert.audioEnabled = action.payload.muteControl;
        },
        setVideoCallCameraControl: (state, action: PayloadAction<{cameraControl: boolean}>) => {
            state.videoAlert.videoEnabled = action.payload.cameraControl;
        }
    }
})

export const { setVideoAlert, setVideoCallInProcess,setVideoCallMuteControl, setVideoCallCameraControl, setVideoCallGroupInProcess } = videoCallAlertSlice.actions;
export default videoCallAlertSlice.reducer;